module.exports = __webpack_public_path__ + "media/images/cplook/remove-8a9faf99618c1172269a9b12fc5860fd.png";